module.exports = "mutation deleteExerciseSave($id: Int!) {\n  deleteEntry(id: $id)\n}"